<template>
  <div>
    <div class="jumbotron">
      <div class="container marketing">
        <div class="row ">
          <div class="col-lg-8 col-xs-10"
               style="width:90%;background: #FFFFFF;padding:5%;border-radius: 5px;margin: 5%">
            <div>
              <el-row>
                <span><b>产品：</b></span>
                <el-autocomplete
                    v-model="state"
                    label-width="auto"
                    :clearable="true"
                    :fetch-suggestions="querySearchAsync"
                    placeholder="请输入产品编号"
                    @select="handleSelect"
                ></el-autocomplete>
              </el-row>

              <a-radio-group v-model:value="dataBindConfig.dataBindType" style="margin: 16px 0">
                <a-radio-button value="1">单关联</a-radio-button>
                <a-radio-button value="2">二级关联</a-radio-button>
                <a-radio-button value="3">三级关联</a-radio-button>
              </a-radio-group>

              <!--              包装规格-->
              <el-row type="flex" align="middle">
                <span v-if="dataBindConfig.dataBindType !=='1'"><b>包装规格：</b></span>
                <el-col :span="12">
                  <div v-if="dataBindConfig.dataBindType==2">
                    <a-space direction="horizontal">
                      <span>1</span>
                      <span>拖</span>
                      <a-input v-model:value="dataBindConfig.packRateSmall" placeholder="小标"/>
                    </a-space>
                  </div>
                  <div v-if="dataBindConfig.dataBindType==3">
                    <a-space direction="horizontal" size="small">
                      <span>1</span>
                      <span>拖</span>
                      <a-input v-model:value="dataBindConfig.packRateMid" placeholder="中标"/>
                      拖
                      <a-input v-model:value="dataBindConfig.packRateSmall" placeholder="小标"/>
                    </a-space>
                  </div>
                </el-col>

              </el-row>

              <!--              操作页面-->
              <a-tabs v-model:activeKey="dataBindConfig.dataBindCodeType" size="small"
                      v-if="dataBindConfig.dataBindType==2">
                <a-tab-pane key="大小" tab="大小标关联"></a-tab-pane>
              </a-tabs>
              <a-tabs v-model:activeKey="dataBindConfig.dataBindCodeType" size="small"
                      v-if="dataBindConfig.dataBindType==3">
                <a-tab-pane key="大中" tab="大中标关联"></a-tab-pane>
                <a-tab-pane key="中小" tab="中小标关联"></a-tab-pane>
              </a-tabs>
              <!--              操作界面-->
              <div>
                <div>
                  <el-button type="primary" size="mini" @click.native="scanCode">扫码</el-button>
                </div>
                <!--                  父级码-->
                <div style="margin: 15px">
                  <h4>{{ dataBind.parentCodeName }}</h4>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>{{ dataBind.parentCode }}</span>
                  <span style="margin-left: 25px;color: red" @click="delParentCode"
                        v-show="dataBind.parentCode">删除</span>
                </div>

                <div class="line"/>
                <!--                  子集码-->
                <div style="margin: 15px">
                  <h4>{{ dataBind.childCodeName }}</h4>
                  <li style="margin-top: 5px" v-for="(item,index) in dataBind.childCodeList" :key="index">{{ item }}
                    <span style="margin-left: 25px;color: red" @click="delChildren(index)">删除</span>
                  </li>
                </div>
                <a-space size="large" style="width: 100%">
                  <el-popconfirm
                      class="delete-popconfirm"
                      title="确认要重置吗?"
                      confirm-button-text="重置"
                      @onConfirm="resetCode('重置成功')"
                      @confirm="resetCode('重置成功')"
                  >
                    <el-button
                        slot="reference"
                        size="mini" type="primary"
                    >重置
                    </el-button>
                  </el-popconfirm>

                  <el-button size="mini" type="primary" style="margin-left: 100px" @click.native="postData">提交
                  </el-button>
                </a-space>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {matchCode} from "../utils/matchCode";
import {getProductList, postDataBind} from "../api/data_bind";

export default {
  data() {
    return {
      bigLen: [],
      midLen: [],
      smallLen: [],
      restaurants: [],
      state: '',
      timeout: null,
      dataBindConfig: {
        selectProduct: '',
        selectProductNumber: '',
        dataBindType: "1", // 2-二级 3-三级
        dataBindCodeType: "大小", // 1-大小码 2-中小码
        packRateMid: null,
        packRateSmall: null,
      },
      dataBind: {
        preScanCodeText: '',
        parentCodeName: '',
        parentCode: '',
        childCodeName: '',
        childCodeList: [],
      },
      productList: [],
    };
  },
  watch: {
    "dataBindConfig.dataBindType": {
      handler: function () {
        if (this.dataBindConfig.dataBindType === '3') {
          if (this.dataBindConfig.dataBindCodeType === '大小') {
            this.dataBindConfig.dataBindCodeType = '大中'
          }
        } else {
          this.dataBindConfig.dataBindCodeType = '大小'
        }
        this.$store.commit("setDataBindConfig", this.dataBindConfig)
      }
    },
    "dataBindConfig": {
      handler: function () {
        if (this.dataBindConfig.dataBindType === '3' && this.dataBindConfig.dataBindCodeType === '大小') {
          this.dataBindConfig.dataBindCodeType = '大中'
        }
        if (this.dataBindConfig.dataBindType === '2') {
          this.dataBindConfig.dataBindCodeType = '大小'
        }
        this.$store.commit("setDataBindConfig", this.dataBindConfig)
      }
    },
  },
  created() {
    if (this.$store.state.dataBindCode !== null) {
      this.dataBind = this.$store.state.dataBindCode
      if (this.dataBind.parentCode === '') {
        this.dataBind.parentCodeName = ''
      }
      if (this.dataBind.childCodeList !== undefined && this.dataBind.childCodeList.length === 0) {
        this.dataBind.childCodeName = ''
      }
      this.$store.commit("setDataBindCode", this.dataBind)
    }
    this.dataBindConfig = this.$store.state.dataBindConfig
    this.bigLen = this.$store.state.codeLen.big
    this.midLen = this.$store.state.codeLen.mid
    this.smallLen = this.$store.state.codeLen.small
    if (this.dataBindConfig.selectProductNumber !== '') {
      this.state = this.dataBindConfig.selectProduct + '(' + this.dataBindConfig.selectProductNumber + ')'
    }

    if (this.$store.state.pre !== 'fromScan') {
      return
    }
    if (this.$store.state.code !== '') {
      this.freshCode()
    }
    this.$store.commit("setPre", '')
  },
  mounted() {
  },
  computed: {
    formItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            labelCol: {span: 4},
            wrapperCol: {span: 14},
          }
          : {};
    },
    buttonItemLayout() {
      const {layout} = this.form;
      return layout === "horizontal"
          ? {
            wrapperCol: {span: 14, offset: 4},
          }
          : {};
    },
  },
  methods: {
    delChildren(i) {
      this.dataBind.childCodeList.splice(i, 1)
      if (this.dataBind.childCodeList.length === 0) {
        this.dataBind.childCodeName = ''
      }
      this.$store.commit("setDataBindCode", this.dataBind)
    },
    delParentCode() {
      this.dataBind.parentCode = ''
      this.$store.commit("setDataBindCode", this.dataBind)
    },
    querySearchAsync(queryString, cb) {
      var params = {isDelete: "false"}
      if (queryString !== '') {
        params = {productNumber: queryString}
      }
      getProductList(params).then((res) => {
        if (res.code == 200) {
          this.restaurants = []
          for (const i in res.data.list) {
            let d = res.data.list[i]
            d['value'] = d.productName + '(' + d.productNumber + ')'
            this.restaurants.push(d)
          }
          clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            cb(this.restaurants);
          }, 300);
        }
      });
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    handleSelect(item) {
      this.dataBindConfig.selectProduct = item.productName
      this.dataBindConfig.selectProductNumber = item.productNumber
    },
    scanCode() {
      if (this.dataBindConfig.packRateMid === null && this.dataBindConfig.dataBindType === '3') {
        this.$message.error('请填写中标包装规格');
        return
      }
      if (this.dataBindConfig.packRateSmall === null && this.dataBindConfig.dataBindType === '2') {
        this.$message.error('请填写小标包装规格');
        return
      }
      if (this.dataBindConfig.selectProduct === '选择产品') {
        this.$message.error('请选择产品');
        return
      }

      if (this.$store.state.isDev) {
        this.$store.commit("setScanCode", "89898992")
        this.freshCode()
        return;
      } else {
        this.$router.push({
          path: '/scanCodePage'
        })
      }
    },
    freshCode() {
      const c = this.$store.state.code;
      if (this.$store.state.dataBindCode == null || c !== this.$store.state.dataBindCode.preScanCodeText) {
        //  新码
        this.recordCode(c)
      } else {
        this.$message.error('重复扫码或码无效：' + c);
        return
      }
      this.dataBind.preScanCodeText = c
      this.$store.commit("setDataBindCode", this.dataBind)
    },
    recordCode(code) {
      const codeName = matchCode(code, this.bigLen, this.midLen, this.smallLen)
      if (this.dataBindConfig.dataBindType !== '1' && !this.dataBindConfig.dataBindCodeType.includes(codeName)) {
        this.$message.error("长度不符合要求，该关联下只可录入" + this.dataBindConfig.dataBindCodeType + '标')
        return
      }

      const parentCodeName = this.dataBindConfig.dataBindCodeType.substring(0, 1)
      const isFinishMsg = this.checkIsFinish()
      if (isFinishMsg !== '') {
        this.$message.error(isFinishMsg)
        return
      }

      if (codeName === '无效') {
        this.$message.error("长度不符合要求，无效码" + code)
        return
      }

      if (this.dataBindConfig.dataBindType === '1') {
        if (codeName !== '小') {
          this.$message.error(code + "：码无效，单关联只可以录入小标")
          return
        }
        // 单标码，直接录入小码
        this.dataBind.childCodeName = '小标'
        this.dataBind.childCodeList.push(code)
        return
      }

      if (this.dataBind.parentCode === '' && codeName === parentCodeName) {
        this.dataBind.parentCodeName = codeName + '标'
        this.dataBind.parentCode = code
      } else {
        if (codeName === parentCodeName) {
          this.$message.error("请扫下一级标签，或删除" + this.parentCodeName)
          return
        }
        this.dataBind.childCodeName = codeName + '标'
        this.dataBind.childCodeList.push(code)
      }
    },
    resetCode(msg) {
      this.dataBind = {
        preScanCodeText: '',
        parentCodeName: '',
        parentCode: '',
        childCodeName: '',
        childCodeList: [],
      };
      this.$store.commit("setDataBindCode", this.dataBind)
      this.$message.success(msg)
      location.reload()
    },
    backCode() {
      this.dataBind.preScanCodeText = '';
      if (this.dataBind.childCodeList.length > 0) {
        this.dataBind.childCodeList.pop()
      } else if (this.dataBind.parentCode !== '') {
        this.dataBind.parentCode = ''
        this.dataBind.parentCodeName = ''
      } else {
        this.$message.error('数据为空，无法回退');
      }
      if (this.dataBind.childCodeList.length == 0) {
        this.dataBind.childCodeName = ''
      }
      this.$store.commit("setDataBindCode", this.dataBind)
    },
    checkIsFinish() {
      if (this.dataBindConfig.dataBindType === '1') {
        return ''
      }
      if (this.dataBindConfig.dataBindType === '2') {
        const smallLen = Number(this.dataBindConfig.packRateSmall) //小码需要数量
        if (this.dataBind.parentCode !== '' && this.dataBind.childCodeList.length === smallLen) {
          return '已录满，符合' + '1大标 ' + this.dataBindConfig.packRateSmall + '小标'
        }
      }
      if (this.dataBindConfig.dataBindType === '3') {
        if (this.dataBindConfig.dataBindCodeType === '大中') {
          const midLen = Number(this.dataBindConfig.packRateMid)
          if (this.dataBind.parentCode !== '' && this.dataBind.childCodeList.length === midLen) {
            return '已录满，符合' + '1大标 ' + this.dataBindConfig.packRateMid + '中标'
          }
        }

        if (this.dataBindConfig.dataBindCodeType === '中小') {
          const smallLen = Number(this.dataBindConfig.packRateSmall)
          if (this.dataBind.parentCode !== '' && this.dataBind.childCodeList.length === smallLen) {
            return '已录满，符合' + '1中标 ' + this.dataBindConfig.packRateSmall + '小标'
          }
        }
      }
      return ''
    },
    postData() {
      if (this.dataBindConfig.dataBindType === '1') {
        if (this.dataBind.parentCode !== '') {
          this.$message.error("单关联只可提交小标，请先删除" + this.dataBind.parentCodeName)
          return
        }
      }
      if (this.dataBindConfig.dataBindType !== '1' && this.checkIsFinish() === '') {
        this.$message.error("请按照包装规格录满数据，再提交")
        return
      }
      const params = {
        parent_number: this.dataBind.parentCode,
        children_number: this.dataBind.childCodeList,
        children_length: this.dataBind.childCodeList.length,
        product_number: this.dataBindConfig.selectProductNumber,
      }
      postDataBind(params).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.resetCode("提交成功")
        } else {
          const invalidParentNumber = res.data.invalidParentNumber
          const invalidChildrenNumber = res.data.invalidChildrenNumber
          if (invalidParentNumber !== '') {
            this.$message.error("该标已被使用，错误的\n" + this.dataBind.parentCodeName + ': ' + invalidParentNumber)
          }
          if (invalidChildrenNumber.length !== 0) {
            this.$message.error("该标已被使用，错误的\n" + this.dataBind.childCodeName + ': ' + invalidChildrenNumber)
          }
        }
      });
    },
    getProductListApi() {
      getProductList().then((res) => {
        if (res.code == 200) {
          this.restaurants = []
          for (const i in res.data.list) {
            let d = res.data.list[i]
            d['value'] = d.productName + '(' + d.productNumber + ')'
            this.restaurants.push(d)
          }
        }
      });
    }
  },
}
;
</script>
<style scoped>
.marketing {
  margin-top: 50px;
}

.line {
  float: right;
  width: 100%;
  height: 1px;
  margin-top: -0.5em;
  background: #d4c4c4;
  position: relative;
  text-align: center;
}

.recharge {
  color: #ff4c34;
}

.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>